var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMobileLineLeft(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 38,
    height: 12,
    viewBox: "0 0 38 12",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26.6667 6C26.6667 8.94552 29.0545 11.3333 32 11.3333C34.9455 11.3333 37.3333 8.94552 37.3333 6C37.3333 3.05448 34.9455 0.666667 32 0.666667C29.0545 0.666667 26.6667 3.05448 26.6667 6ZM0 7H32V5H0L0 7Z",
    fill: "#1D314C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMobileLineLeft);
export default __webpack_public_path__ + "static/media/mobile-line-left.a74ede5229313ad633318784b9efc295.svg";
export { ForwardRef as ReactComponent };